import React from "react";
import { Modal } from "antd";

const YojnaTrackerDetailModal = ({ scheme, colorFor, onClose, onEdit, onDelete }) => {
  const achievementsIndia = scheme.achievementsIndia || [];
  const achievementsUP = scheme.achievementsUP || [];
  const links = scheme.links || [];

  return (
    <Modal
      open
      onCancel={onClose}
      footer={null}
      width={760}
      className="yt-modal"
      closeIcon={null}
    >
      <div className="yt-modal-head">
        <div className="yt-modal-head-actions">
          <button className="yt-icon-btn" title="Edit" onClick={onEdit}>✎</button>
          <button className="yt-icon-btn yt-danger" title="Delete" onClick={onDelete}>🗑</button>
          <button className="yt-icon-btn" title="Close" onClick={onClose}>✕</button>
        </div>
        <span className="yt-cat-tag" style={{ background: colorFor(scheme.category) }}>
          {scheme.category}
        </span>
        <h2>{scheme.scheme}</h2>
        <div className="yt-date">📅 Launched {scheme.launchDateRaw || "— date not recorded"}</div>
      </div>
      <div className="yt-modal-body">
        <p className="yt-section-label">Overview</p>
        <p className="yt-overview-text">{scheme.overview || "No overview provided."}</p>

        {(achievementsIndia.length > 0 || achievementsUP.length > 0) && (
          <div className="yt-impact-grid">
            {achievementsIndia.length > 0 && (
              <div className="yt-impact-panel">
                <h4>🇮🇳 All-India Impact</h4>
                <ul>
                  {achievementsIndia.map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
              </div>
            )}
            {achievementsUP.length > 0 && (
              <div className="yt-impact-panel">
                <h4>📍 Uttar Pradesh Impact</h4>
                <ul>
                  {achievementsUP.map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        )}

        {scheme.additional && (
          <div className="yt-additional-box">
            <strong>Additional note:</strong> {scheme.additional}
          </div>
        )}

        {links.length > 0 && (
          <>
            <p className="yt-section-label">Related Links</p>
            <ul className="yt-links-list">
              {links.map((l, i) => (
                <li key={i}>
                  <span className="yt-link-icon">🔗</span>
                  {l.url ? (
                    <a href={l.url} target="_blank" rel="noopener noreferrer">
                      {l.label || l.url}
                    </a>
                  ) : (
                    <span className="yt-nolink">{l.label}</span>
                  )}
                </li>
              ))}
            </ul>
          </>
        )}
      </div>
    </Modal>
  );
};

export default YojnaTrackerDetailModal;
